<template>
  <div class='center'>
    <div class='NormalTravel'>
      <div class='normed-header'>
        <Header>
          <div v-if="message.checkFlag != 1">
            <span @click="onClickRight" class="delete">修改</span>
            <div style="display: inline-block; width: 8px;"></div>
            <span @click="onClickRightDel" v-if="message.reimbursementFlag !== 2" class="delete">删除</span>
          </div>
          <div v-else>
            <span @click="onClickRightDel" v-if="message.reimbursementFlag !== 2" class="delete">删除</span>
          </div>
        </Header>
        <div>
          <!-- 国家税务局通用定额发票 -->
          <div class="sellerName" v-if="message.invoiceType === '201'">火车票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '202'">飞机票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '01'">增值税专用发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '11'">增值税普通发票（卷式）</div>
          <div class="sellerName" v-else-if="message.invoiceType === '04'">增值税普通发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '207'">出租车</div>
          <div class="sellerName" v-else-if="message.invoiceType === '10'">增值税普通电子发票</div>
          <div class="sellerName" v-else-if="message.invoiceType === '200'">定额发票</div>
        </div>
        <div class='back-color'>
          <div></div>
        </div>
      </div>
      <div class='content'>
        <div class='img'>
          <div @click='handleShowImg'>
            <img :src='getOcrUrl(message.imagePath)' alt='' />
          </div>
          <div>
            <div class='huisuiyunfont'>
              <span>{{ '\ue630' }}</span
              >拍照识别
            </div>
            <div class='huisuiyunfont'>
              <span>{{ '\ue632' }}</span
              >{{ message.createTime ? message.createTime.split(' ')[0] : '' }}
            </div>
            <div class='huisuiyunfont check'>
              <!-- v-if='message.exceptionInfo !="0" && message.exceptionInfo !=null' -->
              <div v-if="message.checkFlag == 0" class="no-check">
                <div class="icon">{{'\ue631'}}</div>
                <div class="check-text">暂未查验</div>
              </div>
              <div v-if="message.checkFlag == 1">
                <div class="icon">{{'\ue631'}}</div>
                <div class="check-text">查验成功</div>
              </div>
              <div v-if="message.checkFlag == 2" class="fail-check">
                <div class="icon">{{'\ue631'}}</div>
                <div class="check-text">查验失败</div>
              </div>
              <div  v-if="message.reimbursementFlag !== 0" :class="[getColor(message.reimbursementFlag)]">
                <div v-if="message.reimbursementFlag === 1" class="icon">{{'\ue66e'}}</div>
                <div v-if="message.reimbursementFlag === 2" class="icon">{{'\ue66d'}}</div>
                <div v-if="message.reimbursementFlag === 3" class="icon">{{'\ue66c'}}</div>
                <div class="check-text" v-if="message.reimbursementFlag === 1">待审批</div>
                <div class="check-text" v-if="message.reimbursementFlag === 2">已完成</div>
                <div class="check-text" v-if="message.reimbursementFlag === 3">已驳回</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class='CardType'>
          <CardType :item='message'></CardType>
        </div> -->
        <div class='money'>
          <!-- 通过判断类型来区分要展示的内容 -->
          <MyCollapse
            v-if="invoiceType == '207'"
            :card='taxiContent'
            :title='taxiTitle'
            :money='true'
          ></MyCollapse>
          <!-- <MyCollapse v-else-if='invoiceType == '201' ' :card='trainContent' :title='trainTitle' :money='true'></MyCollapse> -->
          <div class='money-train' v-else-if="invoiceType == '201'">
            <div class='heard'>金额</div>
            <div class='number'>
              <div class='left iconfont'>
                <span class='money-icon'>{{ '\ue60a' }}</span
                ><span class='money-fonts'>{{ message.amountWithTax }}</span>
              </div>
              <div class='right'>
                <span class='big-size'>{{
                  message.amountWithTaxBig ? message.amountWithTaxBig : ''
                }}</span>
              </div>
            </div>
          </div>
          <MyCollapse
            v-else-if="invoiceType == '202'"
            :card='planeContent'
            :title='planeTitle'
            :money='true'
          ></MyCollapse>
        </div>
        <div class='journey'>
          <!-- 行车信息 -->
          <MyCollapse
            v-if="invoiceType == '207'"
            :card='taxiCourse'
            :title='taxiCourseTitle'
          ></MyCollapse>
          <MyCollapse
            v-else-if="invoiceType == '201'"
            :card='trainCourse'
            :title='trainCourseTitle'
          ></MyCollapse>
          <MyCollapse
            v-else-if="invoiceType == '202'"
            :card='planeCourse'
            :title='planeCourseTitle'
          ></MyCollapse>
        </div>
        <div class='personal'>
          <PersonalCard
            v-if="invoiceType == '201'"
            :item='Personal'
          ></PersonalCard>
          <PersonalCard
            v-else-if="invoiceType == '202'"
            :item='Personal'
          ></PersonalCard>
        </div>
        <div class='invoice'>
          <MustInvoice
            v-if="invoiceType == '207'"
            :title='taxiMustTitle'
            :card='taxiMustCard'
          ></MustInvoice>
          <MustInvoice
            v-else-if="invoiceType == '201'"
            :title='trainMustTitle'
            :card='trainMustCard'
          ></MustInvoice>
          <MustInvoice
            v-else
            :title='planeMustTitle'
            :card='planeMustCrard'
          ></MustInvoice>
        </div>
      </div>
    </div>
    <div class='lookElectornic'>
      <LookElectornic :imgShow.sync="imgShow" :urlImg="message.imagePath"></LookElectornic>
    </div>
  </div>
</template>
<script>
import { NavBar, Icon, Notify, Dialog } from 'vant'
// import CardType from '@/components/CardType'
import { personalInvoicesRequest, officialAccountRequest } from '@services'
import MyCollapse from '@/components/MyCollapse'
import PersonalCard from '@/components/PersonalCard'
import LookElectornic from '@/components/LookElectronic'
import MustInvoice from '@/components/MustInvoice'
import Header from '@/components/Header/index.vue'
export default {
  data () {
    return {
      id: '',
      type: '',
      time: '',
      imgShow: false,
      invoiceType: '', // 判断当前的类型
      message: {}, // 临时存储信息
      taxiContent: {
        Content1: '', // 含税总额
        Content2: '', // 文字版
        Content3: '', // 金额
        Content4: '', // 燃油附加费
        Content5: '' // 交车服务费
      },
      taxiTitle: {
        title: '含税总价',
        title2: '金额',
        title3: '燃油附加费'
      },
      trainContent: {
        Content1: '', // 金额
        Content2: '' // 文字版
      },
      trainTitle: {
        title: '金额'
      },
      planeContent: {
        Content1: '', // 合计金额
        Content2: '', // 文字版
        Content3: '', // 票价
        Content4: '', // 基建费
        Content5: '', // 燃油附加费
        Content6: '', // 保险费
        Content7: '' // 其他税额
      },
      planeTitle: {
        title: '合计金额',
        title2: '票价',
        title3: '基建费',
        title4: '燃油附加费',
        title5: '保险费',
        title6: '其他税额'
      },
      taxiCourseTitle: {
        title: '行程信息',
        title2: '上下车时间',
        title3: '车牌号'
      },
      taxiCourse: {
        Content1: '', // 行程信息
        Content3: '', // 上下车时间
        Content4: '' // 车牌号
      },
      trainCourseTitle: {
        title: '行程信息',
        title2: '席别',
        title3: '座位号',
        title4: '开车时间'
      },
      trainCourse: {
        Content1: '', // 行程信息
        Content3: '', // 席别
        Content4: '', // 座位号
        Content5: '' // 开车时间
      },
      planeCourseTitle: {
        title: '行程信息',
        title2: '客票级别',
        title3: '座位等级',
        title4: '起飞时间',
        title5: '航班号',
        title6: '承运人'
      },
      planeCourse: {
        Content1: '', // 行程信息
        Content3: '', // 客票级别
        Content4: '', // 座位等级
        Content5: '', // 起飞时间
        Content6: '', // 航班号
        Content7: '' // 承运人
      },
      Personal: {
        name: '',
        IdCard: ''
      },
      taxiMustTitle: {
        title: '发票代码',
        title1: '发票号码',
        title2: '开票日期'
      },
      trainMustTitle: {
        title: '车票号',
        title1: '车次号',
        title2: '开票日期',
        title3: '序列号'
      },
      planeMustTitle: {
        title: '电子客票号码',
        title1: '印刷序号',
        title2: '开票日期',
        title3: '航班号'
      },
      taxiMustCard: {
        Content: '',
        Content1: '',
        Content2: ''
      },
      trainMustCard: {
        Content: '',
        Content1: '',
        Content2: '',
        Content3: '',
        Content4: ''
      },
      planeMustCrard: {
        Content: '',
        Content1: '',
        Content2: '',
        Content3: ''
      }
    }
  },
  async mounted () {
    // 一进来的时候我需要根据他的类型来返回对应的title
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    this.time = this.$route.query.time
    const invoiceNo = this.$route.query.no
    if (this.type === '201') {
      this.invoiceType = '201'
      const data = await personalInvoicesRequest.personalInvoices.getNonInvoiceInfo({ invoiceNo })
      this.message = data.result
      this.trainContent.Content1 = this.message.amountWithTax
      this.trainContent.Content2 = this.message.amountWithTaxBig
      this.trainCourse.Content1 =
        this.message.stationGetOn + '-' + this.message.stationGetOff
      this.trainCourse.Content3 = this.message.seat
      this.trainCourse.Content4 = '--'
      this.trainCourse.Content5 = this.message.getOnTime
      this.trainMustCard.Content1 = this.message.trainNumber
      this.trainMustCard.Content2 = this.message.drewDate
      this.trainMustCard.Content = this.message.invoiceNo
      this.trainMustCard.Content3 = '--'
      this.Personal = {
        name: this.message.passengerName,
        IdCard: '--'
      }
    } else if (this.type === '202') {
      this.invoiceType = '202'
      const data = await personalInvoicesRequest.personalInvoices.getNonInvoiceInfo({ invoiceNo })
      this.message = data.result
      this.planeContent.Content1 = this.message.amountWithTax
        ? this.message.amountWithTax
        : '--'
      this.planeContent.Content2 = this.message.amountWithTaxBig
      this.planeContent.Content3 = this.message.amountWithTax
        ? this.message.amountWithTax
        : '--'
      this.planeContent.Content4 = this.message.caacDevelopmentFund
        ? this.message.caacDevelopmentFund
        : '--'
      this.planeContent.Content5 = this.message.fuelSurcharge
        ? this.message.fuelSurcharge
        : '无'
      this.planeContent.Content6 = this.message.insurance ? this.message.insurance : '--'
      this.planeContent.Content7 = '--'
      this.planeCourse.Content1 =
        this.message.detailList[0].flyFrom +
        '-' +
        this.message.detailList[0].flyTo
      this.planeCourse.Content5 = this.message.detailList[0].flyTime
        ? this.message.detailList[0].flyTime
        : '--'
      this.planeCourse.Content6 = this.message.detailList[0].flightNumber
        ? this.message.detailList[0].flightNumber
        : '--'
      this.planeCourse.Content3 = this.message.detailList[0].seat
        ? this.message.detailList[0].seat
        : '--'
      this.planeCourse.Content4 = this.message.detailList[0].seat
        ? this.message.detailList[0].seat
        : '--'
      this.planeCourse.Content7 = this.message.issueBy
        ? this.message.issueBy
        : '--'
      this.planeMustCrard.Content = this.message.invoiceNo
        ? this.message.invoiceNo
        : '--'
      this.planeMustCrard.Content1 = this.message.printSerialNumber
        ? this.message.printSerialNumber
        : '--'
      this.planeMustCrard.Content2 = this.message.drewDate
        ? this.message.drewDate
        : '--'
      this.planeMustCrard.Content3 = this.message.agentCode
        ? this.message.agentCode
        : '--'
      this.Personal = {
        name: this.message.passengerName ? this.message.passengerName : '--',
        IdCard: this.message.passengerUserId
          ? this.message.passengerUserId
          : '--'
      }
    } else {
      this.invoiceType = '207'
      const data = await personalInvoicesRequest.personalInvoices.getNonInvoiceInfo({ invoiceNo })
      this.message = data.result
      this.taxiContent.Content1 = this.message.amountWithTax
      this.taxiContent.Content2 = this.message.amountWithTaxBig
      this.taxiContent.Content3 = this.message.fare || '0.00'
      this.taxiContent.Content4 = this.message.surcharge || '0.00'
      this.taxiContent.Content5 = '0'
      this.taxiCourse.Content1 = this.message.place
      this.taxiCourse.Content3 =
        this.message.timeGetOn + ` - ` + this.message.timeGetOff
      this.taxiCourse.Content4 = '--'
      this.taxiMustCard.Content = this.message.invoiceCode
      this.taxiMustCard.Content1 = this.message.invoiceNo
      this.taxiMustCard.Content2 = this.message.drewDate
    }
  },
  methods: {
    async onClickRightDel () {
      const obj = {
        invoiceNo: this.message.invoiceNo,
        invoiceSource: this.message.invoiceSource
      }
      if (this.message.invoiceCode) {
        obj.invoiceCode = this.message.invoiceCode
      }
      Dialog.confirm({
        title: '提示',
        message: '是否要删除此发票信息!'
      }).then(async () => {
        const result = await personalInvoicesRequest.personalInvoices.deleteCard(obj)
        if (result.success) {
          Notify({ type: 'success', message: '操作成功' })
          this.$router.go(-1)
        } else {
          Notify({ type: 'warning', message: result.message })
        }
      }).catch(() => {
        return false
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    handleShowImg () {
      this.imgShow = true
    },
    async onClickRight () {
      this.$store.commit('invoice/changeInfoInvoice', this.message)
      this.$router.push('/newInvoice/editInvoice')
    },
    async onClickCheck () {
      const res = await officialAccountRequest.weChat.saveCollections([this.message])
      if (res.success) {
        Notify.success('操作成功!')
      } else {
        Notify.error(res.message)
      }
    }
  },
  computed: {
    getOcrUrl () {
      return (url) => {
        if (url) {
          let index = url.indexOf('http')
          let newUrl = url
          console.log(index)
          if (index === -1) {
            newUrl = 'http://huisuiyun.oss-cn-shanghai.aliyuncs.com/' + url
          }
          return newUrl
        }
      }
    },
    getColor () {
      return (i) => {
        switch (i) {
          case 0:
            return ''
          case 1:
            return 'padding'
          case 2:
            return ''
          case 3:
            return 'back'
          default:
            break
        }
      }
    }
  },
  components: {
    // CardType,
    MyCollapse,
    PersonalCard,
    MustInvoice,
    LookElectornic,
    Header,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Notify.name]: Notify,
    [Dialog.name]: Dialog
  }
}
</script>
<style lang='less' scoped src='./style.less'></style>
